import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-select-shift',
  templateUrl: './select-shift.component.html',
  styleUrls: ['./select-shift.component.css']
})
export class SelectShiftComponent implements OnInit {
    labourNo;

    public itemsListWorkShifts: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.labourNo = this.stateService.getStateParams()['labour_no'];
    }

    private async loadWorkShifts() {
        if (!!this.labourNo) {
            this.itemsListWorkShifts = await this.datatask.Post(140, { labour_no: this.labourNo });
        }
    }

    public async goBackToPrevious(event: { item: Item; event: MouseEvent }) {
        if (!!this.itemsListWorkShifts) {
            await this.datatask.Post(141, {
                shift_id: event.item?.item_id,
                labour_no: this.labourNo
            });

            this.stateService.back();
        }
    }

    public cancelToPrevious() {
        this.stateService.back();
    }

    private async init() {
        this.loadWorkShifts();
    }

    ngOnInit() {
        this.init();
    }
}
